export default "__VITE_ASSET__5XCXlyJN__"